import { render, staticRenderFns } from "./LegacyTransferPage.vue?vue&type=template&id=57b7be93&"
import script from "./LegacyTransferPage.vue?vue&type=script&lang=js&"
export * from "./LegacyTransferPage.vue?vue&type=script&lang=js&"
import style0 from "./LegacyTransferPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports